// The wording the share wizard uses for each subject it serves.
//
// The wizard was written for the recording flyover and every line of it said so — "Share a 3D flyover
// of your hike", "Rendering the 3D terrain", "My HiiKER flyover". A hike's Trail Trailer is a
// different video (one orbit of the whole route, not a traversal), and is offered to people as a
// "hike trailer", so it gets its own copy rather than the flyover's. Kept out of FlyoverShare.vue so
// the choice is unit-testable; the keys are spelled out literally because the client i18n bundle only
// ships keys a translation call names (lib/i18n_client_bundle.rb).

import { i18n } from '../../i18n';
import type { ShareKind } from './shareAnalytics';

const t = (key: string): string => i18n.global.t(key);

export interface ShareCopy {
  /** Heading of the wizard's first step. */
  promptTitle: string;
  /** Body of the "Almost there" tip on the generating step. */
  almostThereBody: string;
  /** Email subject when the share has no title of its own. */
  emailSubject: string;
  /** The PRO+ paywall's explanation of what the options strip out. */
  paywallBody: string;
}

export function shareCopy(kind: ShareKind): ShareCopy {
  if (kind === 'trailer') {
    return {
      promptTitle: t('flyover_share.trailer_share.prompt_title'),
      almostThereBody: t('flyover_share.trailer_share.tip_almost_there_body'),
      emailSubject: t('flyover_share.trailer_share.email_subject'),
      paywallBody: t('flyover_share.trailer_share.paywall_body'),
    };
  }
  return {
    promptTitle: t('flyover_share.share_a_3d_flyover_of_your'),
    almostThereBody: t('flyover_share.tip_almost_there_body'),
    emailSubject: t('flyover_share.my_hiiker_flyover'),
    paywallBody: t('flyover_share.pro_members_can_strip_the_flyover'),
  };
}
